module.exports = __webpack_public_path__ + "static/media/anytimewages.8d2f7102.png";